module.exports = __webpack_public_path__ + "img/1406.c1bb3f88.jpg";